import { AlarmLevel, MonitorObjectType, RuleStatus } from './types';

export const ALARM_LEVEL_CONFIG: Record<AlarmLevel, { label: string; color: string }> = {
  [AlarmLevel.LOWEST]: { label: '最低级', color: '#A0D911' },
  [AlarmLevel.LOW]: { label: '低级', color: '#52C41A' },
  [AlarmLevel.MEDIUM]: { label: '中级', color: '#2D8DFF' },
  [AlarmLevel.HIGH]: { label: '高级', color: '#FAAD14' },
  [AlarmLevel.HIGHEST]: { label: '最高级', color: '#FF4D4F' },
};

export const RULE_STATUS_CONFIG: Record<RuleStatus, { label: string; color: string }> = {
  [RuleStatus.ENABLED]: { label: '启用', color: '#52C41A' },
  [RuleStatus.DISABLED]: { label: '禁用', color: '#FF4D4F' },
};

export const MONITOR_OBJECT_TYPE_CONFIG: Record<MonitorObjectType, string> = {
  [MonitorObjectType.PV]: '光伏',
  [MonitorObjectType.LOAD]: '负荷',
  [MonitorObjectType.THERMAL]: '火电',
  [MonitorObjectType.STORAGE]: '储能',
};

export const alarmLevelOptions = Object.entries(ALARM_LEVEL_CONFIG).map(([value, config]) => ({
  value,
  label: config.label,
}));

export const ruleStatusOptions = Object.entries(RULE_STATUS_CONFIG).map(([value, config]) => ({
  value,
  label: config.label,
}));

export const monitorObjectTypeOptions = Object.entries(MONITOR_OBJECT_TYPE_CONFIG).map(([value, label]) => ({
  value,
  label,
}));

export const MONITOR_OBJECT_OPTIONS: Record<MonitorObjectType, { label: string; value: string }[]> = {
  [MonitorObjectType.PV]: [
    { label: '东南一号光伏站', value: 'pv-1' },
    { label: '东南二号光伏站', value: 'pv-2' },
  ],
  [MonitorObjectType.LOAD]: Array.from({ length: 6 }, (_, index) => ({
    label: `电石炉#${index + 1}`,
    value: `calcium-carbide-${index + 1}`,
  })).concat(
    Array.from({ length: 6 }, (_, index) => ({
      label: `硅铁炉#${index + 1}`,
      value: `ferrosilicon-${index + 1}`,
    }))
  ),
  [MonitorObjectType.THERMAL]: [
    { label: '一号火电机组', value: 'thermal-1' },
    { label: '二号火电机组', value: 'thermal-2' },
  ],
  [MonitorObjectType.STORAGE]: [
    { label: '一号储能站', value: 'storage-1' },
    { label: '二号储能站', value: 'storage-2' },
  ],
};

export const dispatchPointOptions = [
  { label: '有功功率设定值', value: 'ACTIVE_POWER_SETPOINT' },
  { label: '目标有功功率', value: 'TARGET_ACTIVE_POWER' },
];

export const feedbackPointOptions = [
  { label: '有功功率实际值', value: 'ACTIVE_POWER_FEEDBACK' },
  { label: '实时有功功率', value: 'REAL_TIME_ACTIVE_POWER' },
];
